export default __webpack_public_path__ + "static/media/bloodyvengeance.13e61fd0.png";